import getEnvironmentRequestTransformer from "./getEnvironmentRequestTransformer";
import RawApiClient, {
  addJsonContentTypeRequestTransformer,
  addXRequestedByHeaderTransformer,
  includeCredentialsRequestTransformer,
  parseBodyAsJsonResponseTransformer,
  throwNon200ResponseTransformer,
} from "./RawApiClient";
class RawProjectTemplatesClient extends RawApiClient {}
const rawProjectTemplatesClient = new RawProjectTemplatesClient({
  requestTransformers: [
    getEnvironmentRequestTransformer("project-templates"),
    addJsonContentTypeRequestTransformer,
    includeCredentialsRequestTransformer,
    addXRequestedByHeaderTransformer,
  ],
  responseTransformers: [
    throwNon200ResponseTransformer,
    parseBodyAsJsonResponseTransformer,
  ],
});
export default rawProjectTemplatesClient;
